import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  createProductsRequest,
  deleteProductRequest,
  getProductsRequest,
  getTemporalToken,
  updateProductRequest,
} from '../../../../billing-api'
import { users } from '../../invoice-issuance/db/users'
import { registerLocalData } from '../fake-data'

// El token se resuelve EN CADA LLAMADA, no al importar el modulo.
// Antes esto corria una sola vez al cargar la pagina: si fallaba, la
// pantalla quedaba rota sin decir por que y sin reintentar nunca.
const obtenerToken = async () => {
  let guardado = null
  try {
    guardado = JSON.parse(localStorage.getItem('userBilligData'))
  } catch (e) {
    guardado = null
  }
  const companyId = guardado?.username
  const user = users.find((u) => u.companyId === companyId)
  if (!user) {
    throw new Error(
      `La empresa "${companyId}" no esta configurada para facturacion.`
    )
  }
  const token = await getTemporalToken(user)
  if (!token) {
    throw new Error('No se pudo autenticar contra el servicio de facturacion.')
  }
  return token
}

export const getProducts = createAsyncThunk(
  'appInvoice/getProducts',
  async () => {
    const token = await obtenerToken()
    const result = await getProductsRequest(token)

    registerLocalData(result)

    return result
  }
)

export const createProducts = createAsyncThunk(
  'appInvoice/createProducts',
  async (product) => {
    const token = await obtenerToken()
    const result = await createProductsRequest(product, token)

    return result
  }
)

export const updateProduct = createAsyncThunk(
  'appInvoice/updateProduct',
  async (product) => {
    const token = await obtenerToken()
    const result = await updateProductRequest(product, token)

    return result
  }
)

export const deleteProduct = createAsyncThunk(
  'appInvoice/deleteProduct',
  async (productId) => {
    const token = await obtenerToken()
    const result = await deleteProductRequest(productId, token)

    return result
  }
)
